import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_legal-services-hub-6/artifacts/481gzg60_WhatsApp%20Image%202025-12-09%20at%201.51.33%20PM.jpeg"
              alt="Soshniti Legal Logo"
              className="h-8 w-auto"
            />
            <span className="text-gray-400 text-sm">
              © {currentYear} Soshniti Legal. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;